module.exports = __webpack_public_path__ + "static/img/234.c3927db.png";